import { render, staticRenderFns } from "./beckoning.vue?vue&type=template&id=454f21c8&scoped=true&"
import script from "./beckoning.vue?vue&type=script&lang=js&"
export * from "./beckoning.vue?vue&type=script&lang=js&"
import style0 from "./beckoning.vue?vue&type=style&index=0&id=454f21c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454f21c8",
  null
  
)

export default component.exports